import { Code, WindowFrame } from "react-solar-set/networkitprogramming";
import { UserCircle } from "react-solar-set/users";
import { Garage } from "react-solar-set/buildinginfrastructure";

export const navItems = [
    {
        title: "Home",
        icon: (
            <Garage
                size={20}
                iconStyle="Outline"
                className="p-0 m-0 self-center block"
            />
        ),
        to: "hero", // Changed from link to to for react-scroll
    },
    {
        title: "Experience",
        icon: (
            <UserCircle
                size={20}
                iconStyle="Outline"
                className="p-0 m-0 self-center block"
            />
        ),
        to: "experience", // Section ID
    },
    {
        title: "Projects",
        icon: (
            <WindowFrame
                size={20}
                iconStyle="Outline"
                className="p-0 m-0 self-center block"
            />
        ),
        to: "projects", // Section ID
    },
    {
        title: "Skills",
        icon: (
            <Code
                size={20}
                iconStyle="Outline"
                className="p-0 m-0 self-center block"
            />
        ),
        to: "skills", // Section ID
    },
];
